import { Moment } from "moment";
import { ICalendarWorkTemplateBase } from "@miplatform/types";

export const CUSTOM_WORK_ORDER_NAME = "Custom Work Order";

export type CustomWorkTemplateBase = ICalendarWorkTemplateBase & {
  orderTemplateName?: string;
  orderId?: string;
};

export interface CreateWorkOrderForm {
  dueDate: Moment | null;
  dueDateTime: Moment | null;
  notes: string;
}

export interface CreateCustomWorkOrderForm {
  workOrderName: string;
  workOrderAbbreviation: string;
  orderId: string;
  workOrderDuration: string;
  color: string;
  dueDate: Moment | null;
  dueDateTime: Moment | null;
  notes: string;
}
